import request from "../../../utils/Request";
import {ATTEndpoints} from "../endpoints";

const addSchedule = async (data: any) => {
  const response = await request.authorizedAxios().post(ATTEndpoints.ATT_SCHEDULE_URI, data)
  return response?.data;
};

const retrieve = async (id: string) => {
  const response = await request.authorizedAxios().get(`${ATTEndpoints.ATT_SCHEDULE_URI}${id}/`);
  return response?.data;
}

const ManualCalc = async (data: any) => {
  const response = await request.authorizedAxios().post(ATTEndpoints.ATT_SCHEDULE_URI_CALC, data)
  return response?.data;
};

const updateSchedule = async (id: string, data: any) => {
  const response = await request.authorizedAxios().put(`${ATTEndpoints.ATT_SCHEDULE_URI}${id}/`, data);
  return response?.data;
};

const bulkDelete = async (data: any) => {
  const response = await request.authorizedAxios().post(ATTEndpoints.ATT_SCHEDULE_URI_BULK_DELETE, data)
  return response?.data;
};

const list = async () => {
  const response = await request.authorizedAxios().get(`${ATTEndpoints.ATT_SCHEDULE_URI}`);
  return response?.data;
}

const ScheduleService = {
  list,
  addSchedule,
  retrieve,
  ManualCalc,
  updateSchedule,
  bulkDelete,
}
export default ScheduleService
